import React, { ReactNode, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  children: ReactNode;
  isVisible: () => boolean;
  noVisibleRender?: () => JSX.Element;
  noVisibleRedirect?: string;
}

const RenderWrapper = ({ children, isVisible, noVisibleRender, noVisibleRedirect }: Props) => {
  // router
  const history = useHistory();

  // side-effects
  useEffect(() => {
    if (noVisibleRedirect && !isVisible()) {
      history.push(noVisibleRedirect);
    }
  }, [])
  
  // render
  if (isVisible()) {
    return (
      <>
        {children}
      </>
    );
  } else if (noVisibleRender) {
    return noVisibleRender();
  } else {
    return null;
  }
}

export default RenderWrapper;
